export default "__VITE_ASSET__CJe2tt7y__"